export default function Heading({title, description} : {title: string, description?: string}) : JSX.Element {
  return (
    <div className="text-center max-w-sm mx-auto">
      <p className="my-3 text-center text-3xl capitalize font-sans tracking-wide">{title}</p>
      {description && <p className="font-light my-6 text-lg">{description}</p>}
    </div>
  )
}